import type { ApprovedPurpose, DemoRole, PolicyDecision, VectorRecord } from "./types";
const DIM = 96;
function hashToken(token:string):number { let h=2166136261; for(let i=0;i<token.length;i++){h^=token.charCodeAt(i);h=Math.imul(h,16777619)} return h>>>0; }
export function embedPrototype(text:string):number[]{ const v=Array(DIM).fill(0); for(const token of text.toLowerCase().match(/[a-z0-9]+/g)??[]){const h=hashToken(token);v[h%DIM]+=((h&256)?1:-1)*(1+Math.min(token.length,12)/12)} const norm=Math.sqrt(v.reduce((s,x)=>s+x*x,0))||1; return v.map(x=>x/norm); }
export function cosine(a:number[],b:number[]):number { let s=0,aa=0,bb=0; for(let i=0;i<a.length;i++){s+=a[i]*b[i];aa+=a[i]*a[i];bb+=b[i]*b[i]} return s/(Math.sqrt(aa)*Math.sqrt(bb)||1); }
export function evaluatePolicy(record: VectorRecord, role: DemoRole, purpose: ApprovedPurpose): PolicyDecision {
  const normalizedRole = role === "Strategy & Informatics" ? "Informatics" : role;
  if (record.domain === "clinical_record") return { allowed: false, reason: "not_indexed" };
  if (!record.indexed || !record.embedding) return { allowed: false, reason: "not_indexed" };
  if (record.aiExposure === "A0") return { allowed: false, reason: "never_exposed" };
  if (record.classification === "C5") return { allowed: false, reason: "restricted_identity" };
  if (record.aiExposure === "A2" && !record.tokenized) return { allowed: false, reason: "a2_requires_tokenization" };
  if (!record.allowedRoles.includes(normalizedRole)) return { allowed: false, reason: "role_mismatch" };
  if (!record.allowedPurposes.includes(purpose)) return { allowed: false, reason: "purpose_mismatch" };
  return { allowed: true, reason: "approved" };
}

export function governedSearch(records: readonly VectorRecord[], query: string, role: DemoRole, purpose: ApprovedPurpose) {
  const queryEmbedding = embedPrototype(query);
  return records
    .map(record => ({ record, score: record.embedding ? cosine(queryEmbedding, record.embedding) : 0, decision: evaluatePolicy(record, role, purpose) }))
    .filter(result => result.decision.allowed)
    .sort((a, b) => b.score - a.score)
    .slice(0, 5);
}
